import React, { useContext, useState, useEffect } from "react";
import "./CartSection.css";
import Swal from "sweetalert2";
import Modal from "../Common/Modal";
import { AppContext } from "../Index";
import { useNavigate } from "react-router-dom";
// import Scanner from "../Scanner"
const CartSection = ({ refelement, rvcRoom }) => {
  const {
    cartItems = [],
    setCartItems,
    addGuest,
    setUserFormData,
    handleCartActions,
    addCondimentsModal,
    setAddCondimentsModal,
    isChecked,
    setIsChecked,
  } = useContext(AppContext);
  const navigate = useNavigate();

  const [userFormError, setUserFormError] = useState({});
  const [addCommentModal, setAddCommentModal] = useState({});
  const [proceedToCheckout, setProceedToCheckout] = useState(false);
  const [addUserDataModal, setAddUserDataModal] = useState({
    active: false,
    firstName: "",
    lastName: "",
    // email: "",
    // phone: "",
    guestCount: "1",
    roomNumber: "",
  });
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  useEffect(() => {
    setAddUserDataModal((prevState) => ({
      ...prevState,
      roomNumber: rvcRoom ? rvcRoom.number : "",
    }));
  }, [rvcRoom]);
  const [updatedCartItems, setUpdatedCartItems] = useState([]);
  const [modalErrorMessage, setModalErrorMessage] = useState("");
  const [generalComment, setGeneralComment] = useState("");
  
  const getQuantity = (id) => {
    let totalQuantity = 0;
    const item = addCondimentsModal;
    if (item.condiments) {
      const condiment = item.condiments.find(
        (cond) => cond.condimentMenuItemId === id,
      );
      if (condiment) {
        totalQuantity += condiment.quantity;
      }
    }
    return totalQuantity;
  };
  
  useEffect(() => {
    setUpdatedCartItems(cartItems);
  }, [cartItems]);

  const sumByGroupType = addCondimentsModal.condiments
    ? addCondimentsModal.condiments.reduce((acc, condiment) => {
      const { condimentGroupTypeValue, quantity } = condiment;
      acc[condimentGroupTypeValue] =
        (acc[condimentGroupTypeValue] || 0) + quantity;
      return acc;
    }, {})
    : {};
    
  const IS_FALSY_VALUE = (value) => {
    if (!value || !value.trim().length) return true;
    return [null, undefined, false].includes(value);
  };

  // NEW: Get item total without condiments
  const getItemTotal = (item) => {
    let sum = 0;
    if (item) {
      cartItems.forEach((it) => {
        if (it.itemCode === item.itemCode) {
          sum = sum + Number(it.quantity) * Number(it.price);
        }
      });
    }
    return (Math.round(sum * 100) / 100).toFixed(2);
  };

  // NEW: Get condiments total for an item
  const getCondimentsTotalForItem = (item) => {
    let sum = 0;
    if (item.condiments && item.condiments.length) {
      item.condiments.forEach(cond => {
        const condimentDetails = item.condimentItems?.flatMap(group =>
          group.itemList.filter(c => c.condimentMenuItemId === cond.condimentMenuItemId)
        )[0];
        if (condimentDetails?.condimentMenuItemPrice) {
          sum += cond.quantity * condimentDetails.condimentMenuItemPrice;
        }
      });
    }
    return (Math.round(sum * 100) / 100).toFixed(2);
  };

  // NEW: Get total condiments price for all items
  const getTotalCondimentsPrice = () => {
    let sum = 0;
    cartItems.forEach((it) => {
      if (it.condiments && it.condiments.length) {
        it.condiments.forEach(cond => {
          const condimentDetails = it.condimentItems?.flatMap(group =>
            group.itemList.filter(c => c.condimentMenuItemId === cond.condimentMenuItemId)
          )[0];
          if (condimentDetails?.condimentMenuItemPrice) {
            sum += cond.quantity * condimentDetails.condimentMenuItemPrice;
          }
        });
      }
    });
    return (Math.round(sum * 100) / 100).toFixed(2);
  };

  // NEW: Get total items price (without condiments)
  const getTotalItemsPrice = () => {
    let sum = 0;
    cartItems.forEach((it) => {
      sum = sum + Number(it.quantity) * Number(it.price);
    });
    return (Math.round(sum * 100) / 100).toFixed(2);
  };

  // Original getTotal (kept for backward compatibility)
  const getTotal = (item) => {
    let sum = 0;
    if (item) {
      cartItems.forEach((it) => {
        if (it.itemCode === item.itemCode) {
          let itemTotal = Number(it.quantity) * Number(it.price);
          // Add condiments total if any
          if (it.condiments && it.condiments.length) {
            it.condiments.forEach(cond => {
              const condimentDetails = it.condimentItems?.flatMap(group =>
                group.itemList.filter(c => c.condimentMenuItemId === cond.condimentMenuItemId)
              )[0];
              if (condimentDetails?.condimentMenuItemPrice) {
                itemTotal += cond.quantity * condimentDetails.condimentMenuItemPrice;
              }
            });
          }
          sum = sum + itemTotal;
        }
      });
    } else {
      cartItems.forEach((it) => {
        let itemTotal = Number(it.quantity) * Number(it.price);
        if (it.condiments && it.condiments.length) {
          it.condiments.forEach(cond => {
            const condimentDetails = it.condimentItems?.flatMap(group =>
              group.itemList.filter(c => c.condimentMenuItemId === cond.condimentMenuItemId)
            )[0];
            if (condimentDetails?.condimentMenuItemPrice) {
              itemTotal += cond.quantity * condimentDetails.condimentMenuItemPrice;
            }
          });
        }
        sum = sum + itemTotal;
      });
    }
    return (Math.round(sum * 100) / 100).toFixed(2);
  };
  
  const validate = (name, value) => {
    switch (name) {
      case "firstName":
        // if (IS_FALSY_VALUE(value)) {
        // 	return "This field is required"
        // }
        return false;
      // case "lastName":
      // if (IS_FALSY_VALUE(value)) {
      // 	return "This field is required"
      // }
      // return false;
      // case "phone":
      // if (IS_FALSY_VALUE(value)) {
      // 	return "This field is required"
      // }
      // if (value && isNaN(value)) {
      //   return "Only Numbers are allowed";
      // }
      // if (value && value.length !== 10) {
      //   return "Phone number must have 10 digits";
      // }
      // return false;
      case "guestCount":
        //
        if (IS_FALSY_VALUE(value)) {
          return "This field is required";
        }
        if (isNaN(value)) {
          return "Only Numbers are allowed";
        }
        return false;
      // case "email":
      // if (IS_FALSY_VALUE(value)) {
      // 	return "This field is required"
      // }
      // if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      //   return "Invalid email";
      // }
      // return false;
      case "roomNumber":
        if (IS_FALSY_VALUE(value)) {
          return "This field is required";
        }
        if (value && !/^[a-z0-9]+$/i.test(value)) {
          return "Invalid Room number";
        }
      default:
        return false;
    }
  };

  const handleChange = (ev) => {
    const { name, value } = ev.target;
    setUserFormError({
      ...userFormError,
      [name]: validate(name, value),
    });
    // if (name === "roomNumber" || name === "phone") {
    //   setModalErrorMessage(
    //     !(addUserDataModal.roomNumber || addUserDataModal.phone)
    //       ? "Please enter Phone Number or Room Number"
    //       : "",
    //   );
    // }
    // if (name === "roomNumber") {
    //   setModalErrorMessage(
    //     !value || !addUserDataModal.phone
    //       ? "Please enter Phone Number or Room Number"
    //       : ""
    //   );
    // }
    // if (name === "phone") {
    //   setModalErrorMessage(
    //     !value || !addUserDataModal.roomNumber
    //       ? "Please enter Phone Number or Room Number"
    //       : ""
    //   );
    // }
    setAddUserDataModal({
      ...addUserDataModal,
      [name]: value,
    });
  };

  // const renderCommentModal = () => {
  //   return (
  //     <form>
  //       <textarea
  //         className="counterstyles p-3 w-100"
  //         value={addCommentModal?.comment || ""}
  //         onChange={(ev) => {
  //           setUpdatedCartItems(
  //             cartItems.map((item) => {
  //               const temp = { ...item };
  //               if (temp.itemCode === addCommentModal.itemCode) {
  //                 temp.comment = ev.target.value;
  //               }
  //               return temp;
  //             }),
  //           );
  //         }}
  //       />
  //     </form>
  //   );
  // };
  
  const renderCommentModal = () => {
    return (
      <form>
        <textarea
          className="counterstyles p-3 w-100"
          value={addCommentModal?.comment || ""}
          placeholder="Add your comment here..."
          onChange={(ev) => {
            setAddCommentModal({
              ...addCommentModal,
              comment: ev.target.value
            });
          }}
        />
      </form>
    );
  };
  
  const renderUserDataModal = () => {
    return (
      <div className="d-flex flex-wrap">
        <div className="user-data mb-3 w-100">
          <label> Guest Name</label>
          <input
            type="text"
            className="w-100  form-control"
            onChange={handleChange}
            name="firstName"
            value={addUserDataModal.firstName}
          />
          <span className="error-validation">{userFormError.firstName}</span>
        </div>
        {/* <div className="user-data mb-3"> */}
        {/*   <label> Last Name</label> */}
        {/*   <input */}
        {/*     type="text" */}
        {/*     className="w-100  form-control" */}
        {/*     onChange={handleChange} */}
        {/*     name="lastName" */}
        {/*     value={addUserDataModal.lastName} */}
        {/*   /> */}
        {/*   <span className="error-validation">{userFormError.lastName}</span> */}
        {/* </div> */}
        {/* <div className="user-data mb-3"> */}
        {/*   <label> */}
        {/*     {" "} */}
        {/*     Phone Number */}
        {/*     <span style={{ color: "tomato", marginLeft: "1px" }}>*</span> */}
        {/*   </label> */}
        {/*   <input */}
        {/*     type="text" */}
        {/*     className="w-100  form-control" */}
        {/*     onChange={handleChange} */}
        {/*     name="phone" */}
        {/*     value={addUserDataModal.phone} */}
        {/*   /> */}
        {/*   <span className="error-validation">{userFormError.phone}</span> */}
        {/* </div> */}
        <div className="d-flex justify-content-between flex-wrap flex-sm-nowrap">
          <div className="col-12 col-sm-4 user-data mb-3">
            <label>
              Room Number
              {/* <span style={{ color: "tomato", marginLeft: "6px" }}>*</span> */}
            </label>
            <input
              type="number"
              readOnly={rvcRoom && true}
              className="w-100  form-control"
              onChange={handleChange}
              maxlength={6}
              name="roomNumber"
              value={addUserDataModal.roomNumber}
            />
            <span className="error-validation">{userFormError.roomNumber}</span>
          </div>
          <div className="col-12 col-sm-7 user-data mb-3">
            <label>
              Guest Count
              {/* <span style={{ color: "tomato", marginLeft: "6px" }}>*</span> */}{" "}
            </label>
            <input
              type="number"
              className="w-100  form-control"
              onChange={handleChange}
              max={5}
              name="guestCount"
              value={addUserDataModal.guestCount}
            />
            <span className="error-validation">{userFormError.guestCount}</span>
          </div>
        </div>
        {/* <div className="user-data mb-3"> */}
        {/*   <label */}
        {/*     style={{ */}
        {/*       display: "flex", */}
        {/*       alignItems: "center", */}
        {/*       justifyContent: "space-between", */}
        {/*     }} */}
        {/*   > */}
        {/*     <span> */}
        {/*       Email */}
        {/*       <span style={{ color: "tomato", marginLeft: "6px" }}>*</span> */}
        {/*     </span> */}
        {/*   </label> */}
        {/*   <input */}
        {/*     type="text" */}
        {/*     className="w-100  form-control" */}
        {/*     onChange={handleChange} */}
        {/*     name="email" */}
        {/*     value={addUserDataModal.email} */}
        {/*   /> */}
        {/*   <span className="error-validation">{userFormError.email}</span> */}
        {/*   <span style={{ fontSize: "0.7rem", color: "#676666" }}> */}
        {/*     This email will only be usesd for sending e-checks */}
        {/*   </span> */}
        {/* </div> */}
        <div
          className="text-center pt-1 pb-1 w-100"
          style={{ display: modalErrorMessage ? "block" : "none" }}
        >
          <span style={{ fontSize: "0.8rem", color: "tomato" }}>
            {modalErrorMessage}
          </span>
        </div>
      </div>
    );
  };

  const updateCondiments = ({
    refId,
    item,
    action,
    condimentGroupTypeValue,
  }) => {
    const temp = [...updatedCartItems];
    const updatedItems = temp.map((cItem) => {
      if (refId === cItem.id) {
        if (!cItem.condiments) {
          if (action === "increment") {
            cItem.condiments = [
              { ...item, quantity: 1, condimentGroupTypeValue },
            ];
          }
        } else {
          const condimentIndex = cItem.condiments.findIndex(
            (condiment) =>
              condiment.condimentMenuItemId === item.condimentMenuItemId,
          );
          if (condimentIndex !== -1) {
            if (action === "decrement") {
              if (cItem.condiments[condimentIndex].quantity > 1) {
                cItem.condiments[condimentIndex].quantity--;
              } else {
                cItem.condiments.splice(condimentIndex, 1);
                if (cItem.condiments.length === 0) {
                  cItem.condiments = null;
                }
              }
            } else if (action === "increment") {
              cItem.condiments[condimentIndex].quantity++;
            }
          } else if (action === "increment") {
            cItem.condiments.push({
              ...item,
              quantity: 1,
              condimentGroupTypeValue,
            });
          }
        }
      }
      setAddCondimentsModal({ ...cItem });
      return cItem;
    });
    setUpdatedCartItems(updatedItems);
  };
  
const renderCondimentsModal = () => {
  return (
    <div className="p-0 md-p-3">
      <div className="pt-2 pb-1 px-2 overflow-styles">
        {addCondimentsModal.condimentItems &&
          addCondimentsModal.condimentItems.length ? (
          addCondimentsModal.condimentItems.map((group) => (
            <div key={group.condimentGroupTypeValue} className="">
              <h5 className="fw-bold d-flex gap-2">
                {group.description}
                {[1, 2, 3].includes(group.condimentGroupTypeValue) && (
                  <span className="text-danger">*</span>
                )}
                {getMaxAllowedQuantity(group.condimentGroupTypeValue) !==
                  Infinity && (
                    <p
                      className={
                        (sumByGroupType[group.condimentGroupTypeValue] || 0) >
                          getMaxAllowedQuantity(group.condimentGroupTypeValue)
                          ? "text-danger fw-bold"
                          : "fw-normal"
                      }
                    >
                      ({sumByGroupType[group.condimentGroupTypeValue] || 0}/
                      {getMaxAllowedQuantity(group.condimentGroupTypeValue)})
                    </p>
                  )}
              </h5>
              <hr />
              {group.itemList.map((item) => (
                <div
                  className="mb-2 flex-column added-item no-border"
                  key={item.condimentMenuItemId}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="col-md-6 col-5 condiment-item-name">
                      <p className="m-0">{item.condimentMenuItemName}</p>
                    </div>
                    <div className="col-4 counter-style">
                      {/* Price above the counter with gap */}
                      {item.condimentMenuItemPrice > 0 && (
                        <small className="text-black d-block text-center mb-1">
                          + AED {item.condimentMenuItemPrice.toFixed(2)}
                        </small>
                      )}
                      <div className="counterstyles m-0">
                        <button
                          type="button"
                          className={`btn pa-1 b-r primary-text f-10 ${getQuantity(item.condimentMenuItemId) === 0
                            ? "disabled"
                            : ""
                            }`}
                          onClick={() =>
                            updateCondiments({
                              refId: group.menuItemId,
                              condimentGroupTypeValue:
                                group.condimentGroupTypeValue,
                              item,
                              action: "decrement",
                            })
                          }
                        >
                          -
                        </button>
                        <span className="f-11 px-2">
                          <b>{getQuantity(item.condimentMenuItemId)}</b>
                        </span>
                        <button
                          type="button"
                          className={`btn pa-1 b-l primary-text f-10 ${isIncrementDisabled(
                            group.condimentGroupTypeValue,
                            item,
                          )
                            ? "disabled"
                            : ""
                            }`}
                          onClick={() =>
                            updateCondiments({
                              refId: group.menuItemId,
                              condimentGroupTypeValue:
                                group.condimentGroupTypeValue,
                              item,
                              action: "increment",
                            })
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center">
            No condiments available for this item
          </div>
        )}
      </div>
    </div>
  );
};
  
  // Helper functions
  const getMaxAllowedQuantity = (condimentGroupTypeValue) => {
    switch (condimentGroupTypeValue) {
      case 1: // Mandatory Single
        return addCondimentsModal.quantity;
      case 4: // Optional Single
        return addCondimentsModal.quantity;
      case 2: // Mandatory Multiple
        return Infinity;
      case 5: // Optional Multiple
        return Infinity;
      case 3: // Mandatory Overall
        return addCondimentsModal.quantity;
      case 6: // Optional Overall
        return addCondimentsModal.quantity;
      default:
        return addCondimentsModal.quantity;
    }
  };

  const isIncrementDisabled = (condimentGroupTypeValue, item) => {
    const currentQuantity = getQuantity(item.condimentMenuItemId);
    const groupSum = sumByGroupType[condimentGroupTypeValue] || 0;
    const maxAllowed = getMaxAllowedQuantity(condimentGroupTypeValue);

    const condimentTypeExists =
      addCondimentsModal?.condiments?.some(
        (condiment) =>
          condiment.condimentGroupTypeValue === condimentGroupTypeValue,
      ) || false;
    switch (condimentGroupTypeValue) {
      case 1: // Mandatory Single
        if (currentQuantity >= maxAllowed) {
          return true;
        }
        if (currentQuantity < 1) {
          if (condimentTypeExists) {
            return condimentTypeExists;
          }
        }
        return false;
      case 4: // Optional Single
        if (currentQuantity >= maxAllowed) {
          return true;
        }
        if (currentQuantity < 1) {
          if (condimentTypeExists) {
            return condimentTypeExists;
          }
        }
        return false;
      case 2: // Mandatory Multiple
      case 5: // Optional Multiple
        return false;
      case 3: // Mandatory Overall
      case 6: // Optional Overall
        return groupSum >= maxAllowed;
      default:
        return currentQuantity >= maxAllowed;
    }
  };
  
  // const renderCondimentsModal = () => {
  //   return (
  //     <div className="p-3">
  //       <div className="pt-2 pb-1 px-2">
  //         {addCondimentsModal.condiments &&
  //         addCondimentsModal.condiments.length ? (
  //           addCondimentsModal.condiments.map((item) => {
  //             return (
  //               <div
  //                 className="mb-2 flex-column added-item no-border"
  //                 key={item.itemCode}
  //               >
  //                 <div className="row d-flex align-items-center">
  //                   <div className="col-md-8">
  //                     <p className="m-0">{item.name} </p>
  //                   </div>
  //                   <div className="col-md-4">
  //                     <div className="counterstyles m-0">
  //                       <button
  //                         type="button"
  //                         className={`btn pa-1 b-r primary-text f-10 ${
  //                           item.quantity === 0 ? "disabled" : ""
  //                         }`}
  //                         onClick={() =>
  //                           updateCondiments({ item, action: "decrement" })
  //                         }
  //                       >
  //                         -
  //                       </button>
  //                       <span className="f-11 pa-2">
  //                         <b>{item.quantity || 0}</b>
  //                       </span>
  //                       <button
  //                         type="button"
  //                         className="btn pa-1 b-l primary-text f-10"
  //                         onClick={() =>
  //                           updateCondiments({ item, action: "increment" })
  //                         }
  //                       >
  //                         +
  //                       </button>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             );
  //           })
  //         ) : (
  //           <div className="d-flex flex-column align-items-center justify-content-center">
  //             No contiments available for this item
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //   );
  // };
  
  const getCheckName = () => {
    if (addUserDataModal.firstName) {
      return addUserDataModal.firstName;
    } else {
      return "EzMenu-Guest";
    }
    // if (addUserDataModal.roomNumber && addUserDataModal.phone) {
    //   return `${addUserDataModal.roomNumber}/${addUserDataModal.phone}`;
    // }
    // return addUserDataModal.roomNumber || addUserDataModal.phone;
  };
  
  const addGuestDatawithout = () => {
    const body = {
      FirstName: "Guest",
      // LastName: "Guest",
      // Email: "guest@gmail.com",
      // LoyaltyProgramId: "102",
      // MobileNumber: "",
      RoomNumber: "",
      // checkname: "",
      // guestCount: 1,
    };
    window.scrollTo(0, 0);
    addGuest(body, 'payNow');
  };
  
  const addGuestData = () => {
    const error = {};
    Object.entries(addUserDataModal).forEach(([key, value]) => {
      const validated = validate(key, value);
      if (validated) {
        error[key] = validated;
      }
    });
    setUserFormError(error);
    // if (!(addUserDataModal.phone || addUserDataModal.roomNumber)) {
    //   setModalErrorMessage("Please enter Phone Number or Room Number");
    //   return false;
    // }
    if (Object.keys(error).length !== 0) {
      return false;
    }

    const tableData = JSON.parse(sessionStorage.getItem("urlParams"));
    sessionStorage.setItem(
      "urlParams",
      JSON.stringify({ ...tableData, MobileNumber: addUserDataModal.phone }),
    );
    const body = {
      FirstName: addUserDataModal.firstName,
      // Email: addUserDataModal.email,
      // LoyaltyProgramId: "102",
      // MobileNumber: addUserDataModal.phone,
      // RoomNumber: addUserDataModal.roomNumber,
      RoomNumber: tableData.actualTableNumber,
      // checkname: getCheckName(),
      // guestCount: addUserDataModal.guestCount,
    };
    setUserFormData({ ...addUserDataModal, checkname: getCheckName() });
    addGuest(body, 'payNow');
    setAddUserDataModal({
      active: false,
      firstName: "",
      guestCount: "1",
      roomNumber: rvcRoom ? rvcRoom.number : "",
    });
    setUserFormError({});
  };

  const checkout = (type) => {
    const tableData = JSON.parse(sessionStorage.getItem("urlParams"));
    console.log(tableData);

    const body = {
      FirstName: 'EzMenu Guest',
      // LoyaltyProgramId: "102",
      // RoomNumber: tableData.rvc,
      RoomNumber: tableData.actualTableNumber,
      // checkname: getCheckName(),
      // guestCount: '1',
    };
    addGuest(body, type);
  };

  useEffect(() => {
    if (updatedCartItems.length > 0) {
      const hasMandatoryCondiments = updatedCartItems.find(
        (item) =>
          !item.condiments &&
          item.condimentItems &&
          item.condimentItems.some((condiment) =>
            condiment.condimentGroupTypeName.includes("Mandatory"),
          ),
      );
      if (hasMandatoryCondiments) {
        setAddCondimentsModal(hasMandatoryCondiments);
      }
    }
  }, [updatedCartItems.length]);
  
  const renderModals = () => {
    // if (addCommentModal.itemCode) {
    //   return (
    //     <Modal
    //       title="Add Comment"
    //       onOk={() => {
    //         setCartItems(updatedCartItems);
    //         setAddCommentModal({});
    //       }}
    //       onClose={() => setAddCommentModal({})}
    //       okText="Submit"
    //       cancelText="Cancel"
    //       modalBody={renderCommentModal()}
    //     />
    //   );
    // }
    if (addCommentModal.itemCode) {
      return (
        <Modal
          title="Add Comment"
          onOk={() => {
            // Update cart items with the comment from modal
            const updatedItems = cartItems.map((item) => {
              if (item.itemCode === addCommentModal.itemCode) {
                return {
                  ...item,
                  comment: addCommentModal.comment || ""
                };
              }
              return item;
            });
            setCartItems(updatedItems);
            setAddCommentModal({});
          }}
          onClose={() => setAddCommentModal({})}
          okText="Submit"
          cancelText="Cancel"
          modalBody={renderCommentModal()}
        />
      );
    }

    if (addCondimentsModal.itemCode) {
      const hasBadCondiments = (condiments, itemQty) => {
        if (!condiments) return true;

        const sumByGroupType = condiments.reduce(
          (acc, { condimentGroupTypeValue, quantity }) => {
            // Skip condiments with group type 2 or 5
            if (condimentGroupTypeValue === 2 || condimentGroupTypeValue === 5)
              return acc;

            acc[condimentGroupTypeValue] =
              (acc[condimentGroupTypeValue] || 0) + quantity;
            return acc;
          },
          {},
        );

        const hasBadChoice = Object.values(sumByGroupType).some(
          (choice) => choice > itemQty,
        );

        if (hasBadChoice) {
          Swal.fire({
            title: "Adjust Condiments",
            text: "Please reduce the condiments",
            icon: "warning",
            confirmButtonColor: "#0f145b",
          });
          return false;
        }

        return true;
      };
      
      const handleMandatoryCondimentsCheck = (
        condiments,
        condimentItems,
        cartItem,
      ) => {
        if (!condimentItems || !condimentItems.length) {
          return true; // No condiment items to check
        }

        const mandatoryGroups = condimentItems.filter((group) =>
          group.condimentGroupTypeName.includes("Mandatory"),
        );

        if (mandatoryGroups.length === 0) {
          return true; // No mandatory groups
        }

        if (!condiments || !condiments.length) {
          showErrorMessage(
            "Select at least one condiment from each mandatory group to continue.",
          );
          return false;
        }

        const missingSelections = mandatoryGroups.filter((group) => {
          const groupCondiments = condiments.filter((condiment) =>
            group.itemList.some(
              (item) =>
                item.condimentMenuItemId === condiment.condimentMenuItemId,
            ),
          );

          // For Mandatory Single (type 1), exactly one item should be selected
          if (group.condimentGroupTypeId === 1) {
            return groupCondiments.length !== 1;
          }

          // For other Mandatory types, at least one item should be selected
          return groupCondiments.length === 0;
        });

        if (missingSelections.length > 0) {
          const errorMessages = missingSelections.map((group) => {
            if (group.condimentGroupTypeId === 1) {
              return `Select exactly one item from "${group.description}"`;
            }
            return `Select at least one item from "${group.description}"`;
          });

          showErrorMessage(errorMessages.join("<br>"));
          return false;
        }

        return true;
      };

      const showErrorMessage = (message) => {
        Swal.fire({
          title: "Mandatory Condiments Required",
          html: message,
          icon: "warning",
          confirmButtonColor: "#0f145b",
          showCancelButton: true,
          cancelButtonText: "Cancel Anyways",
        }).then((result) => {
          if (result.isDismissed) {
            handleCartActions("remove", addCondimentsModal);
            setAddCondimentsModal({});
          }
        });
      };

      const onOkHandler = () => {
        const { condiments, condimentItems, quantity } = addCondimentsModal;
        if (
          handleMandatoryCondimentsCheck(
            condiments,
            condimentItems,
            addCondimentsModal,
          )
        ) {
          if (hasBadCondiments(condiments, quantity)) {
            const updatedCartItems = cartItems.map((item) => {
              if (item.itemCode === addCondimentsModal.itemCode) {
                return {
                  ...item,
                  condiments,
                };
              }
              return item;
            });
            setCartItems(updatedCartItems);
            setAddCondimentsModal({});
          }
        }
      };

      const onCloseHandler = () => {
        const { condiments, condimentItems, quantity } = addCondimentsModal;
        if (handleMandatoryCondimentsCheck(condiments, condimentItems)) {
          if (hasBadCondiments(condiments, quantity)) {
            setAddCondimentsModal({});
          }
        }
      };

      return (
        <Modal
          title="Add / Edit Condiments"
          onOk={onOkHandler}
          onClose={onCloseHandler}
          okText="Submit"
          cancelText="Close"
          modalBody={renderCondimentsModal()}
        />
      );
    }

    if (addUserDataModal.active) {
      let status = false;
      // if (!addUserDataModal.phone || !addUserDataModal.guestCount || !addUserDataModal.email) {
      // if (!addUserDataModal.phone || !addUserDataModal.guestCount) {

      // if (!addUserDataModal.guestCount) {
      // 	setModalErrorMessage("Please enter guest count")
      // }
      return (
        <Modal
          title={`Enter your details`}
          onOk={addGuestData}
          onClose={() => {
            setAddUserDataModal({ active: false });
            setUserFormError({});
          }}
          okText="Submit"
          cancelText="Cancel"
          modalBody={renderUserDataModal()}
          isOkButtonDisabled={status}
        />
      );
    }
  };

  const hasBadCondiments = (condiments, itemQty) => {
    if (!condiments) return true;

    const sumByGroupType = condiments.reduce(
      (acc, { condimentGroupTypeValue, quantity }) => {
        // Skip condiments with group type 2 or 5
        if (condimentGroupTypeValue === 2 || condimentGroupTypeValue === 5)
          return acc;

        acc[condimentGroupTypeValue] =
          (acc[condimentGroupTypeValue] || 0) + quantity;
        return acc;
      },
      {},
    );

    const hasBadChoice = Object.values(sumByGroupType).some(
      (choice) => choice > itemQty,
    );

    if (hasBadChoice) {
      Swal.fire({
        title: "Adjust Condiments",
        text: "Please reduce the condiments",
        icon: "warning",
        confirmButtonColor: "#0f145b",
      });
      return false;
    }

    return true;
  };
  
  return (
    <div className="col-lg-3" ref={refelement}>
      {renderModals()}
      <div className="your-cart mt-3">
        <h4>Your Cart</h4>
        <div className="cart-box">
          <div className="promo-item-selectionstyle__PromoSelectionContaner-k4q2xp-0 jopVCB" />
          <div className="pt-2 pb-1 px-2">
            {(!updatedCartItems.length ? updatedCartItems : cartItems).map(
              (item) => {
                const itemTotal = getItemTotal(item);
                const condimentsTotal = getCondimentsTotalForItem(item);
                
                return (
                  <div
                    className="d-flex justify-content-between align-items-start mb-2 flex-column added-item"
                    key={item.itemcode}
                  >
                    <div className="d-flex flex-wrap flex-lg-wrap align-items-center cart-item-name-add ">
                      <div className="col-12">
                        <div className="d-flex justify-content-between">
                          <span className="cart-item-name">
                            {item.name}
                            <span className="f-10 m-2">
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="info-circle"
                                className="svg-inline--fa fa-info-circle fa-w-16 "
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                              >
                                <path
                                  fill="currentColor"
                                  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                                />
                              </svg>
                            </span>
                          </span>
                          {parseFloat(itemTotal) > 0 && (
                            <span className="currency f-14 f-500">
                              AED {itemTotal}
                            </span>
                          )}
                        </div>
                      </div>
                      
                      {/* Display condiments if they exist - with prices in red */}
                      {item.condiments && item.condiments.length > 0 && (
                        <div className="col-12 mt-2 mb-1">
                          {item.condiments.map((cond, idx) => {
                            const condimentDetails = item.condimentItems?.flatMap(group =>
                              group.itemList.filter(c => c.condimentMenuItemId === cond.condimentMenuItemId)
                            )[0];
                            
                            return (
                              <div key={idx} className="d-flex justify-content-between align-items-center small ps-3">
                                <div className="d-flex align-items-center">
                                  <span className="me-2 text-black">•</span>
                                  <span className="text-black f-14 f-500">{cond.condimentMenuItemName}</span>
                                  {cond.quantity > 1 && (
                                    <span className="ms-1 text-black f-14 f-500">x{cond.quantity}</span>
                                  )}
                                </div>
                                {condimentDetails?.condimentMenuItemPrice > 0 && (
                                  <span className="text-black f-14 f-500">
                                    AED {(cond.quantity * condimentDetails.condimentMenuItemPrice).toFixed(2)}
                                  </span>
                                )}
                              </div>
                            );
                          })}
                          
                        
                        </div>
                      )}
                      
                      <div className="col-12 ms-auto ms-lg-0 mb-1 added-item no-border ">
                        <div className="d-flex flex-lg-wrap align-items-center justify-content-end justify-content-lg-between">
                          <div className="counterstyles m-0 ">
                            <button
                              type="button"
                              className={`btn pa-1 b-r primary-text f-10 ${item.quantity === 1 ? "disabled" : ""
                                }`}
                              onClick={() => {
                                handleCartActions("decrement", item);
                                if (item.condiments) {
                                  if (
                                    !hasBadCondiments(
                                      item.condiments,
                                      item.quantity - 1,
                                    )
                                  ) {
                                    setAddCondimentsModal({
                                      ...item,
                                      quantity: item.quantity - 1,
                                    });
                                  }
                                }
                              }}
                            >
                              -
                            </button>
                            <span className="f-11 pa-2">
                              <b>{item.quantity}</b>
                            </span>
                            <button
                              type="button"
                              className="btn pa-1 b-l primary-text f-10"
                              onClick={() => {
                                // 1. increment quantity
                                handleCartActions("increment", item);

                                // 2. reopen condiments modal for new qty
                                setAddCondimentsModal({
                                  ...item,
                                  quantity: item.quantity + 1,
                                });
                              }}
                            >
                              +
                            </button>
                          </div>
                          <div className="btn-cvr d-flex my-2 ms-2 ms-lg-auto gap-1 gap-lg-0">
                            <span
                              href=""
                              className={`icon-btn pointer ${item.comment ? "item-updated" : ""
                                }`}
                              data-bs-toggle="modal"
                              data-bs-target="#comment-box"
                              onClick={() => setAddCommentModal({
                                ...item,
                                comment: item.comment || ""
                              })}
                            >
                              <img
                                src="/images/comment.svg"
                                alt="comment.svg"
                              />
                            </span>
                            <span
                              href=""
                              className={`icon-btn pointer ${item.condiments?.find((c) => c.quantity > 0)
                                ? "item-updated"
                                : ""
                                }`}
                              data-bs-target="#add-condiments"
                              onClick={() => setAddCondimentsModal(item)}
                            >
                              <img
                                src="/images/food-icon.svg"
                                alt="food-icon.svg"
                              />
                            </span>
                            <span
                              className="f-10 remove-item "
                              onClick={() => handleCartActions("remove", item)}
                            >
                              REMOVE
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex price-cover"></div>
                  </div>
                );
              },
            )}
            <div className="pa-2">
              {/* Items Subtotal */}
              {parseFloat(getTotalItemsPrice()) > 0 && (
                <div className="d-flex justify-content-between align-items-end mb-1 dark-gray">
                  <span>Items <br /> Subtotal</span>
                  <span>
                    <span className="currency-symbol sub-total">AED <br /></span>{" "}
                    <span className="currency sub-total f-14 f-500">
                      {getTotalItemsPrice()}
                    </span>
                  </span>
                </div>
              )}
              
              {/* Condiments Subtotal */}
              {parseFloat(getTotalCondimentsPrice()) > 0 && (
                <div className="d-flex justify-content-between align-items-end mb-2 text-black">
                  <span>Condiments <br /> Subtotal</span>
                  <span>
                    <span className="currency-symbol">AED <br /></span>{" "}
                    <span className="currency f-14 f-500">
                      {getTotalCondimentsPrice()}
                    </span>
                  </span>
                </div>
              )}
              
              {/* Total */}
              {(parseFloat(getTotalItemsPrice()) + parseFloat(getTotalCondimentsPrice())) > 0 && (
                <div className="d-flex justify-content-between align-items-end mb-2 fw-bold" style={{ borderTop: '1px solid #ddd', paddingTop: '8px' }}>
                  <span>Total</span>
                  <span>
                    <span className="currency-symbol">AED</span>{" "}
                    <span className="currency f-14 f-500">
                      {(parseFloat(getTotalItemsPrice()) + parseFloat(getTotalCondimentsPrice())).toFixed(2)}
                    </span>
                  </span>
                </div>
              )}
              
              {!proceedToCheckout ?
                <>
                  <p
                    className="mb-1"
                    style={{ color: 'black', fontSize: '0.7rem', fontStyle: 'italic' }}
                  >
                    Prices are in{' '}
                    <span style={{ fontWeight: 'bold' }}>
                      UAE Dirhams
                    </span>{' '}
                    and inclusive of 5% VAT & 7% Municipality Fee
                  </p>

                  <div className="checkout-confirmation d-flex align-items-start">
                    <input
                      className="mt-1 me-1"
                      type="checkbox"
                      id="confirmCheckbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      disabled={cartItems.length === 0}
                    />
                    <label htmlFor="confirmCheckbox">
                      I acknowledge that delivery time is estimated at approximately 45
                      minutes and may be subject to change based on volume of orders
                    </label>
                  </div>
                  <textarea
                    className="counterstyles p-3 w-100 mt-2"
                    value={generalComment || ""}
                    onChange={(ev) => {
                      setGeneralComment(ev.target.value);
                    }}
                    placeholder="Any special requests?"
                  />
                  <button
                    className="btn btn-secondary mt-2 text-uppercase btn-checkout"
                    onClick={() => {
                      sessionStorage.setItem("cartData", JSON.stringify(cartItems));
                      sessionStorage.setItem("generalComment", JSON.stringify(generalComment));
                      checkout('payNow')
                    }}
                    disabled={cartItems.length === 0 || !isChecked || proceedToCheckout.status}
                  >
                    Proceed to Checkout
                  </button>
                </>
                :
                <div>
                  <label htmlFor="confirmCheckbox" className="d-block mb-2">
                    How would you like to complete your order?
                  </label>
                  <div className="d-flex flex-column flex-sm-row justify-content-between gap-2">
                    <button
                      className="btn btn-secondary w-100 w-sm-auto text-nowrap"
                      style={{ fontSize: "10px" }}
                      onClick={() => {
                        checkout('payLater')
                        setProceedToCheckout(false);
                      }}
                    >
                      Order now, pay later
                    </button>
                    <button
                      className="btn btn-secondary w-100 w-sm-auto text-nowrap"
                      style={{ fontSize: "10px" }}
                      onClick={(ev) => {
                        ev.preventDefault();
                        navigate(`/comming-soon`);
                      }}
                    >
                      Pay now
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="text-center pa-2">
            <p className="f-14 f-500 mb-0" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSection;